module.exports = __webpack_public_path__ + "assets/icons-misc-arrow-right-24-px.54665fc0.svg";